<main>
    <div class="content">
        <div class="paragraph">
            <h2>{{ 'contact_us.All Branches' | translate }}</h2>
            <div class="card" *ngFor="let branch of branches">
                <div class="card-header" *ngIf="currentLanguage === 'en'">
                  {{ branch.branch }}
                </div>
                <div class="card-header" *ngIf="currentLanguage === 'kh'">
                    {{ branch.branchKh }}
                  </div>
                <div class="card-body">
                    <p><span>{{ 'contact_us.Tel' | translate }}: </span>{{ branch.tel }}</p>
                    <p *ngIf="currentLanguage === 'en'"><span>{{ 'contact_us.Address' | translate }}: </span>{{ branch.address }}</p>
                    <p *ngIf="currentLanguage === 'kh'"><span>{{ 'contact_us.Address' | translate }}: </span>{{ branch.addressKh }}</p>
                </div>
            </div>
        </div>
        <div class="bottom-content-poster">
            <img src="images/customer_service/customer_service_1.jpg" alt="">
            <a href="/download-app"><img [src]="baseApiUrl + '/uploads/images/mobile_download/mobile_download_1.jpg'" loading="lazy"></a>
        </div>
    </div>
</main>
